import { UIText3, IconMore16 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

type TUserCardMenuControlProps = {
  onClick(): void;
};

export const UserCardMenuControl: React.VFC<TUserCardMenuControlProps> = ({ onClick }) => {
  return (
    <button type="button" onClick={onClick} className={styles['button']} data-testid="UserCardMenuControl">
      <IconMore16 color="primary_100" height={24} />
      <UIText3 color="primary_100">Еще</UIText3>
    </button>
  );
};
